import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { ApiResponse } from '../../../core/shared/classes/api';
import {Classeur} from "../classes/classeur";


@Injectable()
export class DocumentService {

    constructor (private apiService: ApiService) {}

    updateDocument(id: string, data: any, isDrive = false): Observable<ApiResponse> {
        return this.apiService.put('document/' + id, data, {drive: isDrive ? 1 : 0});
    }

    getClasseurs(query?: {personnelle?: boolean, nom?: string, metier?: string}): Observable<ApiResponse> {
        return this.apiService.get('classeur/', {}, query);
    }

    createClasseur(classeur: Classeur): Observable<ApiResponse> {
        return this.apiService.post('classeur/', JSON.stringify(classeur));
    }

    updateClasseur(id, classeur: Classeur): Observable<ApiResponse> {
        return this.apiService.put(`classeur/${id}`, JSON.stringify(classeur));
    }

    deleteClasseur(id): Observable<ApiResponse> {
        return this.apiService.delete(`classeur/${id}`);
    }


    getDocumentsByResource(resource: string, resourceId?: string, classeurId?: string, isDrive = false, driveName = null): Observable<ApiResponse> {
        return this.apiService.get(resource + (resourceId ? '/' + resourceId : '') + '/document' + '/classeur' + (classeurId ? '/' + classeurId : ''), {}, {drive: isDrive ? 1 : 0, driveName : driveName ? driveName : null});
    }

    getDocumentById(id: string, resource, resourceId,): Observable<ApiResponse> {
        return this.apiService.get('document/resource/' + resource + '/' + resourceId + '/' +id);
    }

    uploadDocument(file: File, resource: string, resourceId: string, classeurId?: string, aclRole?: string, isDrive = false, isWord = false): Observable<ApiResponse> {
        const httpOptions = {reportProgress: true};
        const formData = new FormData();
        formData.append('fileKey', file);
        formData.append('name', file.name);
        return this.apiService.post('upload/resource/' + resource + '/resourceId/' + resourceId +
            (aclRole ? '/aclRolesId/' + aclRole : '') +
            (classeurId ? '/classeur/' + classeurId : ''), formData, httpOptions, {drive: isDrive ? 1 : 0, word: isWord ? 1 : 0});
    }

    downloadDocument(id: string, isDrive = false): Observable<any> {
        return this.apiService.get('document/download/' + id, { responseType: 'arraybuffer' }, {drive: isDrive ? 1 : 0});
    }

    deleteDocument(id: string, resource= null, resourceId = null, isDrive = false): Observable<ApiResponse> {
        if (resource && resourceId && isDrive)
            return this.apiService.delete('document/resource/' + resource + '/' + resourceId  + '/' + id, {drive: isDrive ? 1 : 0});
        return this.apiService.delete('document/' + id, {drive: isDrive});
    }

    getPublicUrl(fileName, isDrive = false): Observable<ApiResponse> {
        return this.apiService.get(`get-public-url/${fileName}`);
    }

    ListDrive(): Observable<ApiResponse> {
        return this.apiService.get('document/list/drive');
    }

    getGiorgettiSites(): Observable<ApiResponse> {
        return this.apiService.get('giorgetti/sites');
    }

    getChampsFusionDocx(): Observable<any> {
        return this.apiService.get('champs-fusion-docx', { responseType: 'arraybuffer' });
    }

    downloadDocx(id: string): Observable<any> {
        return this.apiService.get('download-docx/' + id, { responseType: 'arraybuffer' });
    }

}
